module.exports = __webpack_public_path__ + "media/images/tmp/slide6-f5ed2a0ef1e5db274fe5849ac9bbd029.png";